export const TERMS_AGREEMENT_REQUIRED_KEY = 'terms_agreement_required'
export const TERMS_AGREEMENT_UPDATED_AT_KEY = 'terms_agreement_updated_at'
export const TERMS_PENDING_REDIRECT_KEY = 'terms_pending_redirect'

export function saveTermsAgreementStatus(termsAgreement) {
  try {
    const required = Boolean(termsAgreement && termsAgreement.required)
    localStorage.setItem(TERMS_AGREEMENT_REQUIRED_KEY, required ? 'true' : 'false')
    if (termsAgreement && termsAgreement.updatedAt !== undefined && termsAgreement.updatedAt !== null) {
      localStorage.setItem(TERMS_AGREEMENT_UPDATED_AT_KEY, String(termsAgreement.updatedAt))
    } else {
      localStorage.removeItem(TERMS_AGREEMENT_UPDATED_AT_KEY)
    }
  } catch (e) {
    // ignore storage errors
  }
}

export function shouldRequireTermsAgreement() {
  try {
    return localStorage.getItem(TERMS_AGREEMENT_REQUIRED_KEY) === 'true'
  } catch (e) {
    return false
  }
}

export function markTermsAgreementAccepted() {
  try {
    localStorage.setItem(TERMS_AGREEMENT_REQUIRED_KEY, 'false')
  } catch (e) {
    // ignore storage errors
  }
}

export function clearTermsAgreementStatus() {
  try {
    localStorage.removeItem(TERMS_AGREEMENT_REQUIRED_KEY)
    localStorage.removeItem(TERMS_AGREEMENT_UPDATED_AT_KEY)
    clearTermsPendingRedirect()
  } catch (e) {
    // ignore storage errors
  }
}

function isSafeRedirectPath(path) {
  return typeof path === 'string'
    && path.startsWith('/')
    && !path.startsWith('//')
    && !path.includes('://')
    && !path.startsWith('/login')
}

export function saveTermsPendingRedirect(path) {
  try {
    if (isSafeRedirectPath(path)) {
      sessionStorage.setItem(TERMS_PENDING_REDIRECT_KEY, path)
    }
  } catch (e) {
    // ignore storage errors
  }
}

export function consumeTermsPendingRedirect() {
  try {
    const path = sessionStorage.getItem(TERMS_PENDING_REDIRECT_KEY)
    sessionStorage.removeItem(TERMS_PENDING_REDIRECT_KEY)
    return isSafeRedirectPath(path) ? path : null
  } catch (e) {
    return null
  }
}

export function clearTermsPendingRedirect() {
  try {
    sessionStorage.removeItem(TERMS_PENDING_REDIRECT_KEY)
  } catch (e) {
    // ignore storage errors
  }
}
